import type {HalImageDescriptor, HalImagePhysical} from "@cm/hal"
import {getBytesPerChannel, getNumChannels} from "@cm/hal"
import {WebGl2ImageCacheBase} from "#webgl2/webgl2-image-cache-base"
import {WebGl2ImagePhysical} from "#webgl2/webgl2-image-physical"

export class WebGl2ImageCachePhysical extends WebGl2ImageCacheBase {
    protected cacheName = "physical"

    protected estimateImageSizeInBytes(descriptor: HalImageDescriptor): number {
        const {width, height, channelLayout, dataType} = descriptor
        const numChannels = getNumChannels(channelLayout)
        const bytesPerChannel = getBytesPerChannel(dataType)
        return width * height * numChannels * bytesPerChannel
    }

    protected allocImage(descriptor: HalImageDescriptor): HalImagePhysical {
        return new WebGl2ImagePhysical(this.halContext, descriptor)
    }
}
